import * as Sentry from '@sentry/react';
import * as Router from 'react-router';
import { useEffect } from 'react';
import { CONFIG } from '../config';

/**
 * 使用 Sentry 异常上报
 * 集成方法参考 https://docs.sentry.io/platforms/javascript/guides/react/
 */
class Reporter {

  private enable = true;

  init(enable = true): void {
    this.enable = enable;
    if (!this.enable) {
      return;
    }

    Sentry.init({
      environment: CONFIG.SENTRY_ENV,
      dsn: CONFIG.SENTRY_URL,
      integrations: [
        /**
         * 禁用默认的异常上报，在全局异常处理中手动上报
         */
        Sentry.globalHandlersIntegration({
          onunhandledrejection: false,
          onerror: false
        }),

        /**
         * ReactRouter的Tracing上报
         */
        Sentry.reactRouterV7BrowserTracingIntegration({
          useEffect,
          useLocation: Router.useLocation,
          useNavigationType: Router.useNavigationType,
          createRoutesFromChildren: Router.createRoutesFromChildren,
          matchRoutes: Router.matchRoutes
        })
      ],

      /**
       * 采样率，值1.0会保证100%事务上报到服务器端，正式环境应该降低这个值
       */
      tracesSampleRate: 1.0
    });
  }

  captureMessage = Sentry.captureMessage;
  captureException = Sentry.captureException;

}

/**
 * 重写 createBrowserRouter 方法，使其支持 Sentry 的路由跟踪
 */
export const createBrowserRouter = Sentry.wrapCreateBrowserRouterV7(Router.createBrowserRouter);
export const reporter = new Reporter();
